import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import cx from 'classnames';

const ProgressBarContainer = styled.ul`
  position: relative;
  top: 12px;
  display: flex;
  flex: 1;

  li {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    margin-right: 84px;
    border: 2px solid var(--cc_color_button_background_subtle);
    border-radius: 50%;
    color: var(--cc_color_text_default);
    font-size: 14px;
    font-weight: 500;

    &:last-of-type {
      margin-right: 0;
    }

    &::after {
      content: '';
      position: absolute;
      right: -86px;
      width: 84px;
      height: 2px;
      background: var(--cc_color_button_background_subtle);
    }

    &:last-of-type::after {
      display: none;
    }

    &.active {
      border-color: var(--cc_color_brand_primary);
      color: var(--cc_color_brand_primary);
    }

    &.completed {
      background: var(--cc_color_brand_primary);
      border-color: var(--cc_color_brand_primary);
      color: white;
    }

    &.completed::after {
      background: var(--cc_color_brand_primary);
    }

    span {
      position: absolute;
      top: -24px;
      left: -32px;
      width: 96px;
      color: var(--cc_color_text_default);
      font-size: 11px;
      text-align: center;
      white-space: nowrap;
    }
  }
`;

const ProgressBar = ({ currentStep, labels, totalSteps }) => {
  const renderListItems = () => {
    const listItems = [];
    for (let i = 0; i < totalSteps; i += 1) {
      const progressNumber = i + 1;
      const progressBarItemClasses = cx('progress-bar-item', {
        active: progressNumber === currentStep,
        completed: progressNumber < currentStep,
      });

      listItems.push(
        <li key={i} className={progressBarItemClasses}>
          {labels[i]}
          <div>{progressNumber}</div>
        </li>,
      );
    }
    return listItems;
  };

  return <ProgressBarContainer>{renderListItems()}</ProgressBarContainer>;
};

ProgressBar.propTypes = {
  currentStep: PropTypes.number.isRequired,
  labels: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  ),
  totalSteps: PropTypes.number.isRequired,
};

export default ProgressBar;
